if (!customElements.get('piecework-brag-bar')) {
  customElements.define(
    'piecework-brag-bar',
    class PieceworkBragbar extends HTMLElement {
      constructor() {
        super();
        const sliderElement = this.querySelector('.splide');

        new Splide(sliderElement, {
          type: 'loop',
          arrows: true,
          pagination: false,
          focus: 'center',
          perPage: 1,
          perMove: 1,
          padding: { right: '29vw', left: '29vw' },
          breakpoints: {
            768: {
              padding: { right: '20vw', left: '20vw' },
            },
            1200: {
              padding: { right: '25vw', left: '25vw' },
            },
          },
        }).mount();

        document.addEventListener('shopify:section:load', () => {
          new Splide(sliderElement, {
            type: 'loop',
            arrows: true,
            pagination: false,
            focus: 'center',
            perPage: 1,
            perMove: 1,
            padding: { right: '10vw', left: '10vw' },
            breakpoints: {
              768: {
                padding: { right: '10vw', left: '10vw' },
              },
              1200: {
                padding: { right: '25vw', left: '25vw' },
              },
            },
          }).mount();
        });
      }
    }
  );
}
